export default __webpack_public_path__ + "static/media/Sky1.87232f1e.png";